import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import LogicaAPI from "./logicaapi";

var VoucherCode = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(VoucherCode, _LogicaAPI);

  var _super = _createSuper(VoucherCode);

  function VoucherCode() {
    _classCallCheck(this, VoucherCode);

    return _super.apply(this, arguments);
  }

  _createClass(VoucherCode, [{
    key: "check",
    value: function () {
      var _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(code, _ref) {
        var _this$config;

        var productId, paymentMethodId, params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                productId = _ref.productId, paymentMethodId = _ref.paymentMethodId;
                // APIの使用上コースIDも指定できるが、TVODの購入時にしか使わない想定なので除外
                params = {
                  product_id: productId,
                  payment_method_id: paymentMethodId
                };

                if ((_this$config = this.config) !== null && _this$config !== void 0 && _this$config.userId) {
                  params.user_id = this.config.userId;
                }

                return _context.abrupt("return", this.get("/api/v1/voucher_codes/check/".concat(code), {
                  params: params
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function check(_x, _x2) {
        return _check.apply(this, arguments);
      }

      return check;
    }()
  }]);

  return VoucherCode;
}(LogicaAPI);

export default VoucherCode;